import { createClient } from "@supabase/supabase-js";

//connect to supabase
export const supabase = createClient("https://czfedeplminnpapweglk.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN6ZmVkZXBsbWlubnBhcHdlZ2xrIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODE4NTIwODIsImV4cCI6MTk5NzQyODA4Mn0.FL_HmYYrveZbUrK4FBOe-7tJW3uefi5jB2EPlHirDq4");


export async function forgotPassword(email){
      //prepare response
  const response = {};
  response.data = {};
  response.status = 'failed';
  
  const { data, error } = await supabase.auth.resetPasswordForEmail(email)


  //failed to create
  if(error){
    console.log("error" , error);
    response.message = error;
    return response;
  }

  //if success, grab data
  response.status = 'success';
  response.data = data;

  return response;


}
/**
 * get account information
 * @return {[type]} [description]
 */
export async function getAccountData(uid) {

    //grab data from specific user
    const { data } = await supabase.from("users").select().eq('uid', uid);
    
    return data;
  
}


/**
 * get account integrations
 * @return {[type]} [description]
 */
export async function apiGetAccountSettingIntegration(uid, type) {


    //grab data from specific user
    const { data } = await supabase.from("integrations").select(type).eq('uid', uid);
   
    return data[0][type];
    
  
}


/**
 * normalize a single Notion page/database record into a flat shape the UI
 * can render. Notion (and our exchange endpoint) expose titles in a handful
 * of different shapes, so we try them in order and fall back gracefully.
 * @param  {Object|string} item raw stored item
 * @return {Object|null}        { id, title, type, url } or null
 */
function normalizeNotionItem(item) {
    if (!item) return null;

    //sometimes only an id/title string is stored
    if (typeof item === 'string') {
        return { id: item, title: item, type: 'page', url: null };
    }

    const id = item.id || item.page_id || item.database_id || null;
    const type = item.object || item.type || 'page';
    const url = item.url || item.public_url || null;

    //titles come in a few shapes across the Notion API
    let title =
        (typeof item.title === 'string' && item.title) ||
        item.name ||
        item.plain_text ||
        item?.child_page?.title ||
        item?.child_database?.title ||
        null;

    //page/database objects expose the title as a rich-text array
    if (!title && Array.isArray(item.title)) {
        title = item.title.map((t) => t?.plain_text || t?.text?.content || '').join('').trim() || null;
    }

    //full page objects carry the title inside a "title" type property
    if (!title && item.properties) {
        const titleProp = Object.values(item.properties).find((p) => p?.type === 'title');
        if (titleProp && Array.isArray(titleProp.title)) {
            title = titleProp.title.map((t) => t?.plain_text || '').join('').trim() || null;
        }
    }

    return { id, title: title || 'Untitled', type, url };
}

/**
 * get the Notion integration's stored connection data along with a
 * normalized list of the pages/databases currently being synced, so we can
 * surface them in-app rather than relying on Notion's reauthorize screen.
 * @param  {string} uid owner user id
 * @return {Object}     { status, workspace, items }
 */
export async function apiGetNotionSyncedItems(uid) {

    const response = { status: 'failed', workspace: null, items: [] };

    const { data, error } = await supabase
        .from('integrations')
        .select('notion')
        .eq('uid', uid);

    if (error || !data || data.length === 0) {
        if (error) response.message = error.message;
        return response;
    }

    let notion = data[0]?.notion;
    if (!notion) return response;

    //the column may hold a JSON string or an already-parsed object
    if (typeof notion === 'string') {
        try {
            notion = JSON.parse(notion);
        } catch (e) {
            return response;
        }
    }

    response.status = 'success';
    response.workspace = {
        name: notion.workspace_name || notion.workspaceName || null,
        icon: notion.workspace_icon || notion.workspaceIcon || null,
    };

    //the synced list can live under a few keys depending on what the
    //exchange endpoint persisted; take the first array we recognise
    const candidates = [
        notion.pages,
        notion.databases,
        notion.results,
        notion.content,
        notion.synced,
        notion.items,
        Array.isArray(notion) ? notion : null,
    ];
    const list = candidates.find((c) => Array.isArray(c)) || [];

    response.items = list.map(normalizeNotionItem).filter(Boolean);

    return response;
}

/**
 * get account integrations
 * @return {[type]} [description]
 */
export async function apiGetAccountSettingIntegrationData(uid) {

    //prepare response
    const response = {};

    //grab data from specific user
    const { data } = await supabase.from("integrations").select().eq('uid', uid);
    
    //grab from array
    const integrations = data[0];

    //list all available or installed integrations
    const available = [];
    const installed = [];

    
    const s3_integration = {};
    s3_integration.name = "Amazon S3";
    s3_integration.slug = "amazon_s3";
    s3_integration.desc = "Cloud storage by AWS";
    s3_integration.img = "/img/thumbs/aws-s3.png";

    const notion_integration = {};
    notion_integration.name = "Notion";
    notion_integration.slug = "notion";
    notion_integration.desc = "Productivity and collaboration platform.";
    notion_integration.img = "/img/thumbs/notion.png";

    //TODO add support for gd
    //const gd_integration = {};
    //gd_integration.name = "Google Drive";
    //gd_integration.slug = "google_drive";
    //gd_integration.desc = "Cloud storage by Google";
    //gd_integration.img = "/img/thumbs/google-drive.png";
    //(integrations?.google_drive) ? installed.push(gd_integration) : available.push(gd_integration);

    //add to relevant object based on current setup
    (integrations?.amazon_s3) ? installed.push(s3_integration) : available.push(s3_integration);
    (integrations?.notion) ? installed.push(notion_integration) : available.push(notion_integration);

    //add to object
    response.installed = installed;
    response.available = available;


    return response;
    
  
}



export async function removeIntegration(uid, name){

   //prepare response
  const response = {};
  response.data = {};
  response.status = 'failed';
  
  //prepare payload
  var payload = {};
  payload.uid = uid;
  payload[name] = null;

  const { data, error } = await supabase.from('integrations').upsert(payload).select();

  //failed to create
  if(error){
    console.log("error" , error);
    response.message = error;
    return response;
  }

  //if success, grab data
  response.status = 'success';
  response.data = data;

  return response;
  

}


export async function storeIntegration(uid, name, json){

   //prepare response
  const response = {};
  response.data = {};
  response.status = 'failed';
  
  //prepare payload
  var payload = {};
  payload.uid = uid;
  payload[name] = json;

  const { data, error } = await supabase.from('integrations').upsert(payload).select();

  //failed to create
  if(error){
    console.log("error" , error);
    response.message = error;
    return response;
  }

  //if success, grab data
  response.status = 'success';
  response.data = data;

  return response;
  

}




export async function signUpWithEmail(email, password){

   //prepare response
  const response = {};
  response.data = {};
  response.status = 'failed';
  
  const { data, error } = await supabase.auth.signUp({ email: email, password: password})

  //failed to create
  if(error){
    console.log("error" , error);
    response.message = error;
    return response;
  }

  //if success, grab data
  response.status = 'success';
  response.data = data;

  return response;
  

}

/**
 * get account billings
 * @return {[type]} [description]
 */
export async function apiGetAccountBillings(uid) {


    //grab data from specific user
    const { data } = await supabase.from("billings").select().eq('uid', uid);
 
    const response = {};
    response.billings = data;
   
    return response;
    
  
}


/**
 * get account backups
 * @return {[type]} [description]
 */
export async function apiGetAccountIntegrationBackups(uid) {

    //grab data from specific user, hiding rows the user has archived
    const { data } = await supabase
        .from("backups")
        .select()
        .eq('uid', uid)
        .not('archived', 'is', true)
        .order('id', { ascending: false });

    //pretty data 
    data.forEach(function(item) { 
        item.size_mb = (item.size / 1048576).toFixed(2);

        let date = new Date(item.created_at);
        let options = { year: 'numeric', month: 'long', day: 'numeric' };
        let formattedDate = date.toLocaleDateString('en-US', options);

        item.created_at = formattedDate;

    });


    const response = {};
    response.backups = data;


    return response;


}

/**
 * archive a single backup so it stops showing in the user's list
 * @param  {number|string} id   backup row id
 * @param  {string}        uid  owner user id (must match auth.uid for RLS)
 * @return {Object}             { status, data | message }
 */
export async function apiArchiveBackup(id, uid) {
    const response = { status: 'failed', data: null };

    const { data, error } = await supabase
        .from('backups')
        .update({ archived: true })
        .eq('id', id)
        .eq('uid', uid)
        .select();

    if (error) {
        response.message = error.message;
        return response;
    }

    response.status = 'success';
    response.data = data;
    return response;
}

/**
 * sign into an account with an email and password
 * @param  {[type]} email    [description]
 * @param  {[type]} password [description]
 * @return {[type]}          [description]
 */
export async function signInWithEmail(email, password) {

  //prepare response
  const response = {};
  response.data = {};
  response.status = 'failed';
  response.message = 'User not found';

  //login
  const { data, error } = await supabase.auth.signInWithPassword({ email: email, password: password})

  //return error if we failed
  if(error) return response;
  
  //if success, grab data
  response.status = 'success';
  response.data = data;

  return response;
}